import {
  Icon as BlueprintIcon,
  Card,
  CardProps,
  Elevation,
} from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as React from 'react';
import {
  Heading,
  Icon,
  IconComponentType,
} from 'vet-bones/design-system/components';

interface ProductCardProps extends CardProps {
  description: string;
  label: string;
  logo: IconComponentType;
  link: string;
  testId: string;
}

export const ProductCard: React.VFC<ProductCardProps> = ({
  description,
  label,
  logo,
  link,
  testId,
}) => {
  return (
    <a
      className="sd-drawer-publish-project__explorer-link__product-card"
      data-testid={testId}
      href={link}
      rel="noopener noreferrer"
      target="_blank"
    >
      <Card elevation={Elevation.ONE} interactive role="button">
        <span className="sd-product-card-icon">
          <BlueprintIcon icon={IconNames.SHARE} />
        </span>
        <span className="sd-product-card-logo">
          <Icon IconComponent={logo} size={70} />
          <Heading
            className="sd-product-card-logo-stardog"
            size="2xl"
            weight="light"
          >
            STARDOG
          </Heading>
          <Heading
            className="sd-product-card-logo-label"
            size="2xl"
            weight="semibold"
          >
            {label}
          </Heading>
        </span>
        <p className="sd-product-card-description">{description}</p>
      </Card>
    </a>
  );
};
